import { useIntl } from 'react-intl'
import { FormattedMessage } from 'components/Commons/Translation'

import { Container, Title, Message, Contact } from './styled'

import translations from './translations'

function Empty({ className, dataTestId }) {
  const { formatMessage } = useIntl()
  return (
    <Container data-testid={dataTestId} className={className}>
      <Title>
        <FormattedMessage {...translations.title} />
      </Title>
      <Message>
        <FormattedMessage
          {...translations.message}
          values={{
            link: function MailLink(chunks) {
              return (
                <Contact color="tertiary" href={`mailto:${formatMessage(translations.mailTo)}`}>
                  {chunks}
                </Contact>
              )
            },
          }}
        />
      </Message>
    </Container>
  )
}

export default Empty
